import styles from "./Header.module.css";

export function Header() {
  return (
    <header className={styles.siteHeader}>
      <div className={styles.brand}>
        <img
          src="/stippets-logo.png"
          alt="Stippets logo"
          className={styles.brandMark}
        />
        <div className={styles.brandText}>
          <h1 className={styles.brandTitle}>Stippets</h1>
        </div>
      </div>
    </header>
  );
}
